export default (axios) => ({
  async dbGetPlatforms() {
    const url = '/common/platforms/'
    return (await axios.get(url)).data.data
  }
})



// WEBPACK FOOTER //
// ./src/pkg/api/main.js